import React from "react";
import { Phone, Mail } from "lucide-react";

const Footer = () => {
  return (
    <footer className="mt-20 bg-gray-100 text-sm text-gray-600 text-center py-6">
      <div className="flex flex-col sm:flex-row justify-center gap-4 mb-2">
        <span className="flex items-center gap-2 justify-center">
          <Phone className="w-4 h-4" /> (201) 375-5729
        </span>
        <span className="flex items-center gap-2 justify-center">
          <Mail className="w-4 h-4" /> CustomerService@BeLawnSmart.com
        </span>
      </div>
      &copy; {new Date().getFullYear()} LawnSmartPro, LLC. All rights reserved.
    </footer>
  );
};

export default Footer;
